var ProductsCardCarousel = {
	isTouchDevice: function() {
		return (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
	},
	init: function(){
		var self = this;
		$( '.swiper-container-product-card:not(.swiper-container-initialized)' ).each(
			function(){
				var $container     = $( this );
				var $productHolder = $container.closest( '.product-card-image' );
				var swiper         = new Swiper(
					$container.get( 0 ),
					{
						loop: true,
						slidesPerView: 1,
						allowTouchMove: ! ! $container.closest( '.product-card-category' ).length,
						preventClicks: false,
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						speed: 100,
						autoplay: {
							delay: 2000,
						},
						breakpoints: {
							576: {
								allowTouchMove: false,
							}
						}
					}
				);

				swiper.autoplay.stop();

				if ( ! self.isTouchDevice() ) {
					$productHolder.mouseenter(
						function() {
							swiper.autoplay.start();
						}
					).mouseleave(
						function() {
							swiper.autoplay.stop();
						}
					)
				}
			}
		);
	}
}
jQuery(
	function() {
		'use strict';
		ProductsCardCarousel.init();
		$(window).on('berocket_lmp_end', function(){
			ProductsCardCarousel.init();
		});
	}
);
